import { useEffect, useState } from "react";
import { CheckCircle, X } from "@phosphor-icons/react";

export default function PaymentReturn() {
  const params = new URLSearchParams(window.location.search);
  const [cancelled] = useState(() => params.get("checkout") === "cancelled");
  const isPopup = typeof window !== "undefined" && !!window.opener && window.opener !== window;

  useEffect(() => {
    if (isPopup) {
      const t = setTimeout(() => { try { window.close(); } catch { /* ignore */ } }, 1200);
      return () => clearTimeout(t);
    }
    // Popup was blocked → this loaded as a full page. Bounce back to billing to verify.
    const sid = params.get("session_id");
    const q = cancelled ? "?checkout=cancelled" : (sid ? `?session_id=${sid}` : "");
    const t = setTimeout(() => { window.location.replace(`/subscription${q}`); }, 900);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0E103F] px-6" data-testid="payment-return">
      <div className="text-center text-white max-w-sm">
        <span className="w-16 h-16 rounded-3xl bg-white/10 flex items-center justify-center mx-auto mb-5">
          {cancelled ? <X size={30} weight="bold" className="text-white/80" /> : <CheckCircle size={32} weight="fill" style={{ color: "#00A859" }} />}
        </span>
        <h1 className="font-heading font-black text-2xl tracking-tight">
          {cancelled ? "Checkout cancelled" : "Payment complete 🎉"}
        </h1>
        <p className="text-white/70 text-sm mt-2">
          {cancelled ? "No payment was taken." : "Your subscription is being activated."}{" "}
          {isPopup ? "You can close this window." : "Taking you back…"}
        </p>
        {isPopup && (
          <button onClick={() => { try { window.close(); } catch { /* ignore */ } }} data-testid="payment-return-close"
            className="mt-5 inline-flex items-center gap-2 bg-[#F37A24] text-white px-5 py-2.5 rounded-lg text-sm font-semibold hover:opacity-90 transition-opacity">
            Close window
          </button>
        )}
      </div>
    </div>
  );
}
